var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVariant1 = function SvgVariant1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 172 172"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 71.418,
    stroke: "#F07D00",
    strokeDasharray: "0.1 4",
    strokeLinecap: "round",
    transform: "rotate(135 86 86)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F07D00",
    d: "m153.182 49.21 4.738 1.813-1.189 4.933 4.81 9.14 4.411-18.3-17.58-6.725z",
    opacity: 0.3
  })));
};
export default SvgVariant1;